import enterView from 'enter-view';

export default {
    init() {
        let videos = document.querySelectorAll('video[autoplay]');
        if(videos && videos.length > 0) {
            this.videos = videos;
            this.pauseVideos();
            this.inViewInit();
        }
    },
    pauseVideos() {
        Array.from(this.videos).forEach(video => {
            video.pause();
        })
    },
    inViewInit() {
        if(this.videos && this.videos.length > 0) {
            enterView({
                selector: this.videos,
                enter: video => {
                    if (video && typeof video.play !== "undefined") {
                        try {
                            video.play();
                        } catch(e) {
                            console.warn("Video failed to play");
                        }
                    }
                },
                exit: video => {
                    if (video && typeof video.pause !== "undefined") {
                        try {
                            video.pause();
                        } catch (e) {
                            console.warn("Video failed to render");
                        }
                    }
                }
            })
        }
    }
}
